export const FLAGSHIPS = [
    {
        city: "London",
        country: "United Kingdom",
        flag: "UK",
        street: "65 Brushfield St",
        postal: "E1 6AA",
        hours: "8–11 AM",
        maps: "https://www.google.com/maps/place/UKnitwear/@51.5191837,-0.0800332,17z/data=!3m1!4b1!4m6!3m5!1s0x487605fb4a6eae5f:0x1d3e732873cff85!8m2!3d51.5191805!4d-0.0751623!16s%2Fg%2F11z9x1kws9?authuser=0&hl=en&entry=ttu&g_ep=EgoyMDI2MDUwNi4wIKXMDSoASAFQAw%3D%3D",
        gallery: [
            {
                src: "/stockists/london-1.png",
                alt: "UKnitwear storefront in London",
            },
            {
                src: "/stockists/london-2.png",
                alt: "Close-up of a striped UKnitwear sweater in London",
            },
            {
                src: "/stockists/london-3.png",
                alt: "Customer wearing a floral UKnitwear cardigan in London",
            },
        ],
    },
    {
        city: "San Francisco",
        country: "United States",
        flag: "US",
        street: "100 Alemany Boulevard",
        postal: "CA 94110",
        hours: "Sunday 7 AM - 3 PM",
        maps: "https://www.google.com/maps/search/?api=1&query=100+Alemany+Boulevard+San+Francisco+CA+94110",
        gallery: [
            {
                src: "/stockists/san-francisco-1.png",
                alt: "UKnitwear market setup in San Francisco",
            },
        ],
    },
    {
        city: "San Diego",
        country: "United States",
        flag: "US",
        street: "3366 Adams Ave",
        postal: "CA 92116",
        hours: "11 AM - 5 PM",
        maps: "https://www.google.com/maps/search/?api=1&query=3366+Adams+Ave+San+Diego+CA+92116",
        gallery: [
            {
                src: "/stockists/san-diego-1.png",
                alt: "Rack of UKnitwear sweaters at the San Diego location",
            },
            {
                src: "/stockists/san-diego-2.png",
                alt: "Two customers wearing UKnitwear sweaters in San Diego",
            },
            {
                src: "/stockists/san-diego-3.png",
                alt: "UKnitwear booth setup at the San Diego location",
            },
        ],
    },
    {
        city: "Coming Soon",
        comingSoon: true,
    },
];
